/* eslint-disable perfectionist/sort-maps */
import { tabAtom } from './atoms/tabAtom';
import { Susp } from './lib/Susp';
import { useSetAtom } from 'jotai';
import { Component, Images, Layers, SquarePen } from 'lucide-react';
import React, { type FC, useEffect } from 'react';
import { Route, type RouteProps } from 'wouter';

export type AppTab = {
  href: string;
  icon: React.ReactElement;
  title: string;
};

export const appTabs = new Map([
  [
    'content' as const,
    {
      href: '/content',
      icon: <SquarePen size={16} />,
      title: 'Content',
    } as AppTab,
  ],
  [
    'models' as const,
    {
      href: '/models',
      icon: <Layers size={16} />,
      title: 'Models',
    } as AppTab,
  ],
  [
    'components' as const,
    {
      href: '/components',
      icon: <Component size={16} />,
      title: 'Components',
    } as AppTab,
  ],
  [
    'media' as const,
    { href: '/media', icon: <Images size={16} />, title: 'Media' } as AppTab,
  ],
]);

export type AppTabKey = typeof appTabs extends Map<infer K, AppTab> ? K : never;

export const AppRoute: FC<
  RouteProps & {
    readonly tab?: AppTabKey;
  }
> = ({ children, tab, ...rest }) => {
  const setTab = useSetAtom(tabAtom);
  useEffect(() => {
    if (tab) {
      setTab(tab);
    }
  }, [setTab, tab]);
  return (
    <Susp>
      <Route {...rest}>{children}</Route>
    </Susp>
  );
};
